import { ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import React, { useState } from 'react';

type TDateInputProps = {
  controlled?: boolean;
  className?: string;
  name?: string;
  label: string;
  inputValue: string;
  onChange: (value: string) => void;
  markAsRequired?: boolean;
  disabled?: boolean;
  error?: boolean;
  helpText?: string;
  min?: string;
  max?: string;
};

const DateInput: React.FC<TDateInputProps> = ({
  className,
  name,
  label,
  inputValue,
  onChange,
  markAsRequired,
  disabled,
  error,
  helpText,
  min,
  max,
}) => {
  const [isActive, setIsActive] = useState(false);
  const showAsDate = isActive || !!inputValue;

  return (
    <div className={className}>
      <label
        className={`flex flex-col rounded-[.25rem] border px-3 py-2 transition-colors ${
          error ? 'border-error-500' : 'border-neutral-300 focus-within:border-primary-base'
        } ${disabled ? 'bg-neutral-100 opacity-60' : 'bg-white'}`}>
        <Text variant={ETextStyleVariant.SmallRegular} className="text-neutral-600">
          {label}
          {markAsRequired && <span className="text-error-500">{' *'}</span>}
        </Text>
        <input
          name={name}
          type={showAsDate ? 'date' : 'text'}
          placeholder="MM/DD/YYYY"
          value={inputValue}
          disabled={disabled}
          min={min}
          max={max}
          onFocus={() => setIsActive(true)}
          onBlur={() => setIsActive(false)}
          onChange={e => onChange(e.target.value)}
          className="p-0 text-base bg-transparent border-0 outline-none text-neutral-900 placeholder:text-neutral-500"
        />
      </label>
      {helpText && (
        <Text
          variant={ETextStyleVariant.SmallRegular}
          className={`mt-2 ${error ? 'text-error-500' : 'text-gray-700'}`}>
          {helpText}
        </Text>
      )}
    </div>
  );
};

export default DateInput;
